interface INotificationsStore {
  haveUnreadNotifications: boolean;
}

export const initialState: INotificationsStore = {
  haveUnreadNotifications: false,
};
